import { render, staticRenderFns } from "./PrepConfig.vue?vue&type=template&id=6fb639b0&scoped=true"
import script from "./PrepConfig.vue?vue&type=script&lang=js"
export * from "./PrepConfig.vue?vue&type=script&lang=js"
import style0 from "./PrepConfig.vue?vue&type=style&index=0&id=6fb639b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb639b0",
  null
  
)

export default component.exports